<template>
    <div class="Verified-Reviews">
        <ObfuscateLink v-if="isObfuscate" :dataHref="verifiedReviewsDatas.url_redirect" :className="'VerifiedReviews__container'">
            <template v-slot:content>
                <div class="VerifiedReviews__logo">
                    <img :src="`${baseUrlMedia}/media/topheaderblock/${verifiedReviewsDatas.logo}`" alt="logo avis vérifiés" />
                </div>
                <div class="VerifiedReviews__content">
                    <div class="VerifiedReviews__rate">
                        <img :src="`${baseUrlMedia}/media/topheaderblock/${verifiedReviewsDatas.rate_image}`" alt="logo avis vérifiés" />
                    </div>
                    <p :inner-html.prop="verifiedReviewsDatas.rate_text"></p>
                    <p :inner-html.prop="verifiedReviewsDatas.review_text"></p>
                </div>
                <div class="pleats"></div>
            </template>
        </ObfuscateLink>
        
        <a v-else :href="verifiedReviewsDatas.url_redirect" class="VerifiedReviews__container" target="_blank">
            <div class="VerifiedReviews__logo">
                <img :src="`${baseUrlMedia}/media/topheaderblock/${verifiedReviewsDatas.logo}`" alt="logo avis vérifiés" />
            </div>
            <div class="VerifiedReviews__content">
                <div class="VerifiedReviews__rate">
                    <img :src="`${baseUrlMedia}/media/topheaderblock/${verifiedReviewsDatas.rate_image}`" alt="logo avis vérifiés" />
                </div>
                <p :inner-html.prop="verifiedReviewsDatas.rate_text"></p>
                <p :inner-html.prop="verifiedReviewsDatas.review_text"></p>
            </div>
            <div class="pleats"></div>
        </a>
    </div>
</template>

<script>
import ObfuscateLink from '@/components/ObfuscateLink/ObfuscateLink.vue';

export default {
    name: 'VerifiedReviews',

    components: { 
        ObfuscateLink
    },

    props: {
        verifiedReviewsDatas: {
            type: Object,
            required: true,
            default: {}
        },
        
        baseUrlMedia: {
            type: String,
            required: false,
            default: process.env.VUE_APP_API_BASE_URL
        },

        isObfuscate: false,
    },

    data() {
        return {
            verifiedReviewsDatas: {},
        }
    },

    mounted() {
        if( document.getElementById('Header')?.classList.contains('catalog-category-view') ){
            this.isObfuscate = true;
        }
        if( document.getElementById('Header')?.classList.contains('catalog-product-view') ){
            this.isObfuscate = true;
        }
    },
    
}
</script>

<style lang="scss">
.VerifiedReviews__container {
    position: relative;
    align-self: flex-start;
    padding: 12px 15px 8px 0;
    box-shadow: 0px 0px 15px rgba(11, 35, 45, 0.2);
    border-radius: 0px 0px 10px 5px;

    @media ($mq-large-desktop) {
        display: flex;
        margin-left: 20px;
    }

    @media (min-width: 1400px) {
        margin-left: 3%;
    }

    .VerifiedReviews__logo {
        width: 40px;
        height: 40px;

        img {
            margin-left: -10px;
            transition: transform .2s ease-in;
        }  
    }

    .VerifiedReviews__rate {
        height: 15px;
        margin-bottom: 5px;

        img {
            max-height: 100%;
        }
    }

    .VerifiedReviews__content {

        p {
            font-size: 1.2rem;
            margin: 0;
            font-style: italic;
        }

        span {
            color: $c-black;
            font-weight: 700;
        }
    }

    .pleats {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 10px;
        height: 10px;
        background: #D7DFE2;
        border-radius: 0px 0px 10px 0px;
    }

    &:hover {
        .VerifiedReviews__logo {
            img {
                transform: scale(1.1);
            }  
        }

        span {
            color: $color-red;
        }
    }
}

</style>